import { Action, Dispatch } from 'redux'
import { State } from 'index'
import dexieDb from 'lib/db'
import { switchBackToAdminAction } from 'reducks/auth/actions'
import { initRootState } from 'reducks/auth/operations'
import { push } from 'connected-react-router'

const switchBackToAdmin = () => {
  return async (dispatch: Dispatch<Action>, getState: () => State) => {
    // スーパー管理者の場合、indexedDB内の情報を初期化する
    if (getState().auth.is_admin) {
      await dexieDb.auth.put({
        uid: getState().auth.uid,
        is_admin: getState().auth.is_admin,
        is_signed_in: getState().auth.is_signed_in,
        role: 0,
        brand_id: undefined,
        shop_id: undefined,
        store_id: undefined,
      })
    }
    initRootState(dispatch)
    dispatch(switchBackToAdminAction())
    dispatch(push('/admin/shops'))
  }
}

export default switchBackToAdmin
